<template>
  <div class="sections">

    <city></city>
    <passion></passion>
    <clients></clients>
    <mr-bot></mr-bot>
    <bot-arm></bot-arm>

    <about></about>
    <facts></facts>
    <team></team>
    <positions></positions>
    <ready></ready>

    <blog></blog>
    <site-footer></site-footer>

  </div>
</template>

<script>
    import city from './sections/City.vue';
    import passion from './sections/Passion.vue';
    import clients from './sections/Clients.vue';
    import mrBot from './sections/Mrbot.vue';
    import botArm from './sections/botArm.vue';
    import about from './sections/About.vue';
    import facts from './sections/Facts.vue';
    import team from './sections/Team.vue';
    import positions from './sections/Positions.vue';
    import ready from './sections/Ready.vue';
    import blog from './sections/Blog.vue';
    import siteFooter from './sections/Footer.vue';

    import {mapMutations} from 'vuex';

    export default {
        name: 'Sections',
        components: {
            city,
            passion,
            clients,
            mrBot,
            botArm,
            about,
            facts,
            team,
            positions,
            ready,
            blog,
            siteFooter
        },
        data() {
            return {
                sections: this.$options.components
            };
        },
        mounted() {
            /*
            setTimeout(() => {
              this.storeSections(this.sections);
            }, 2000);
            */
        },
        methods: {
            ...mapMutations([
                'addSection'
            ]),
            storeSections(sections) {
                /*
                for (let x in sections) {
                  if (!sections[x].hasOwnProperty('data') || sections[x].data().exclude_from_nav) continue;
                  let $section = this.$el.querySelector('[' + sections[x]._scopeId + ']');
                  if (!$section) {
                    continue;
                  }
                  this.addSection({
                    //title: this.$t('sections.' + sections[x].data().nav_title),
                    title: sections[x].data().nav_title,
                    name: sections[x].name,
                    scroll_to: $section.offsetTop,
                    height: $section.scrollHeight
                  });
                }
                */
            }
        }
    };
</script>

<style lang="scss">
  .sections, .scroll-section {
    overflow-x: hidden;
    overflow-y: hidden;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sections.vue